import BotonManualHeader from "../../components/BotonManualHeader";
import React, { useState } from "react";
import firebaseApp from "../../firebase/credenciales";
import {
  getFirestore,
  collection,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import {
  Container,
  Card,
  Form,
  Button,
  Table,
  Spinner,
  Alert,
  Badge,
  Row,
  Col,
} from "react-bootstrap";
import {
  FaSearch,
  FaCalendarAlt,
  FaExclamationTriangle,
  FaFilePdf,
  FaUser,
  FaFile,
  FaImage,
  FaPaperclip
} from "react-icons/fa";

const db = getFirestore(firebaseApp);

function AusenciasDetalle() {
  const [dni, setDni] = useState("");
  const [loading, setLoading] = useState(false);
  const [ausencias, setAusencias] = useState([]);
  const [nombre, setNombre] = useState("");
  const [error, setError] = useState("");

  const handleBuscar = async () => {
    if (!dni.trim()) return;

    setLoading(true);
    setAusencias([]);
    setNombre("");
    setError("");

    try {
      const refAusencias = collection(db, `ausencias/${dni}/ausencias`);
      const snap = await getDocs(refAusencias);

      const data = [];
      snap.forEach((doc) => {
        data.push({ id: doc.id, ...doc.data() });
      });

      setAusencias(data);
      if (data.length > 0) {
        setNombre(data[0].nombreCompleto);
      } else {
        setError("No se encontraron registros para este DNI");
      }
    } catch (err) {
      console.error("Error al buscar datos:", err);
      setError("Error al buscar la información. Intente nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (timestamp) => {
    if (!timestamp?.seconds) return "-";
    return new Date(timestamp.seconds * 1000).toLocaleDateString("es-PE", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      timeZone: "America/Lima",
    });
  };

  const getEstadoBadge = (estado) => {
    const variants = {
      Aprobado: "success",
      Pendiente: "warning",
      Rechazado: "danger",
      "En Proceso": "info",
    };
    return <Badge bg={variants[estado] || "secondary"}>{estado}</Badge>;
  };

  const getTipoBadge = (tipo) => {
    const variants = {
      "Licencia por enfermedad": "danger",
      "Licencia por maternidad": "info",
      "Licencia sin goce": "warning",
      "Permiso personal": "secondary",
    };
    return <Badge bg={variants[tipo] || "primary"}>{tipo}</Badge>;
  };

  const renderDocumentosIcons = (documentos) => {
    if (!Array.isArray(documentos) || documentos.length === 0) {
      return <span className="text-muted">-</span>;
    }

    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'];
    const pdfExtensions = ['pdf'];

    return (
      <div className="d-flex align-items-center justify-content-center gap-2">
        {documentos.map((doc, index) => {
          const extension = doc.nombre?.split('.').pop()?.toLowerCase();
          let icon, color;

          if (imageExtensions.includes(extension)) {
            icon = FaImage;
            color = "text-primary";
          } else if (pdfExtensions.includes(extension)) {
            icon = FaFilePdf;
            color = "text-danger";
          } else {
            icon = FaFile;
            color = "text-secondary";
          }

          const IconComponent = icon;

          return (
            <a
              key={index}
              href={doc.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`${color} text-decoration-none`}
              style={{ fontSize: "1.2em" }}
              title={doc.nombre || `Documento ${index + 1}`}
            >
              <IconComponent />
            </a>
          );
        })}
      </div>
    );
  };

  return (
    <div
      className="min-vh-100"
      style={{
        background: "linear-gradient(135deg, #ffffffff 0%, #ffffffff 100%)",
        minHeight: "100vh",
        width: "100vw",
        maxWidth: "100%",
        padding: "20px 0",
      }}
    >
      <Container fluid style={{ width: "90%", maxWidth: "100%" }}>
        <Card
          className="shadow-lg border-0"
          style={{
            borderRadius: "15px",
            overflow: "hidden",
            minHeight: "90vh",
          }}
        >
          <Card.Header
            className="text-white py-4 position-relative"
            style={{
              background: "linear-gradient(45deg, #2c3e50, #3498db)",
              borderBottom: "3px solid #f39c12",
            }}
          >
          <div
            className="position-absolute end-0 top-50 translate-middle-y me-4"
            style={{ zIndex: 10 }}
          >
            <BotonManualHeader />
          </div>
            <div className="text-center">
              <h2 className="fw-bold mb-1">
                <FaCalendarAlt className="me-3" />
                Detalle de Ausencias
              </h2>
              <p className="mb-0 opacity-75">
                Consulte el historial de ausencias por DNI
              </p>
            </div>
          </Card.Header>

          <Card.Body className="p-4" style={{ backgroundColor: "#f8f9fa" }}>
            <Card className="shadow-sm border-0 mb-4">
              <Card.Body className="p-4">
                <Row className="align-items-end">
                  <Col md={6} lg={4}>
                    <Form.Group className="mb-3 mb-md-0">
                      <Form.Label className="fw-semibold text-dark">
                        <FaUser className="me-2" />
                        Documento de Identidad
                      </Form.Label>
                      <Form.Control
                        type="text"
                        value={dni}
                        onChange={(e) =>
                          setDni(e.target.value.replace(/\D/g, ""))
                        }
                        placeholder="Ingrese DNI del colaborador"
                        className="form-control-lg"
                        maxLength={8}
                        disabled={loading}
                        style={{ borderRadius: "10px" }}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4} lg={3}>
                    <Button
                      variant="primary"
                      size="lg"
                      onClick={handleBuscar}
                      disabled={loading || !dni.trim()}
                      className="w-100"
                      style={{
                        borderRadius: "10px",
                        background: "linear-gradient(45deg, #3498db, #2980b9)",
                        border: "none",
                      }}
                    >
                      {loading ? (
                        <>
                          <Spinner
                            animation="border"
                            size="sm"
                            className="me-2"
                          />
                          Buscando...
                        </>
                      ) : (
                        <>
                          <FaSearch className="me-2" />
                          Buscar
                        </>
                      )}
                    </Button>
                  </Col>
                </Row>
              </Card.Body>
            </Card>

            {nombre && (
              <Alert
                variant="info"
                className="border-0 shadow-sm mb-4"
                style={{ borderRadius: "10px" }}
              >
                <div className="d-flex align-items-center">
                  <FaUser className="me-3 fs-4" />
                  <div>
                    <h5 className="fw-bold mb-1">Colaborador Encontrado</h5>
                    <p className="mb-0 fs-6">
                      {nombre} - DNI: {dni}
                    </p>
                  </div>
                </div>
              </Alert>
            )}

            {error && (
              <Alert
                variant="warning"
                className="border-0 shadow-sm mb-4"
                style={{ borderRadius: "10px" }}
              >
                <div className="d-flex align-items-center">
                  <FaExclamationTriangle className="me-3 fs-4" />
                  <div>
                    <h6 className="fw-bold mb-1">Sin Resultados</h6>
                    <p className="mb-0">{error}</p>
                  </div>
                </div>
              </Alert>
            )}

            {(ausencias.length > 0 || (nombre && !loading)) && (
              <Card
                className="shadow-sm border-0"
                style={{ borderRadius: "15px" }}
              >
                <Card.Header className="bg-primary text-white py-3">
                  <div className="d-flex align-items-center">
                    <FaCalendarAlt className="me-2" />
                    <h5 className="mb-0 fw-semibold">Historial de Ausencias</h5>
                    <Badge bg="light" text="primary" className="ms-auto">
                      {ausencias.length} registro(s)
                    </Badge>
                  </div>
                </Card.Header>
                <Card.Body className="p-0">
                  <div style={{ maxHeight: "500px", overflowY: "auto" }}>
                    <Table responsive hover className="mb-0">
                      <thead className="table-light sticky-top">
                        <tr>
                          <th className="fw-semibold border-0">Tipo</th>
                          <th className="fw-semibold border-0">Estado</th>
                          <th className="fw-semibold border-0">Motivo</th>
                          <th className="fw-semibold border-0">Fecha Inicio</th>
                          <th className="fw-semibold border-0">Fecha Fin</th>
                          <th className="fw-semibold border-0 text-center">Días</th>
                          <th className="fw-semibold border-0 text-center">Solicitud</th>
                          <th className="fw-semibold border-0 text-center">
                            <FaPaperclip className="me-1" />
                            Adjuntos
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {ausencias.length === 0 ? (
                          <tr>
                            <td
                              colSpan={8}
                              className="text-center text-muted py-4"
                            >
                              <FaExclamationTriangle className="me-2" />
                              No hay ausencias registradas
                            </td>
                          </tr>
                        ) : (
                          ausencias.map((a, idx) => (
                            <tr key={a.id || idx}>
                              <td>{getTipoBadge(a.tipo)}</td>
                              <td>{getEstadoBadge(a.estado)}</td>
                              <td
                                className="text-truncate"
                                style={{ maxWidth: "200px" }}
                              >
                                {a.motivo || "-"}
                              </td>
                              <td>{formatDate(a.fechaInicio)}</td>
                              <td>{formatDate(a.fechaFin)}</td>
                              <td className="text-center">
                                <Badge bg="info">{a.totalDias || 0}</Badge>
                              </td>
                              <td className="text-center">
                                {a.pdfUrl ? (
                                  <Button
                                    variant="outline-danger"
                                    size="sm"
                                    href={a.pdfUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ borderRadius: "8px" }}
                                  >
                                    <FaFilePdf className="me-1" />
                                    Ver PDF
                                  </Button>
                                ) : (
                                  <span className="text-muted">-</span>
                                )}
                              </td>
                              <td className="text-center">
                                {renderDocumentosIcons(a.documentos)}
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </Table>
                  </div>
                </Card.Body>
              </Card>
            )}
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
}

export default AusenciasDetalle;